import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext } from './ModalContext';

interface SuccessModalProps {
  successActionFn?: (...args: any[]) => void;
  title?: string;
  icon?: React.ReactNode;
  description?: string;
  btnLabel: string;
  className?: string;
  hasCancelBtn?: boolean;
  width?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  successActionFn,
  title,
  icon,
  description,
  btnLabel,
  className,
  hasCancelBtn,
  width = '520px',
}) => {
  const modalContext = useContext(ModalContext);

  const onClick = (e: any) => {
    modalContext?.setShowModal(false);
    successActionFn && successActionFn();
  };

  return (
    <Container width={width}>
      <SuccessViewWrapper>
        <SuccessView>
          <IconArea className={className ? className : ''}>{icon}</IconArea>
          <Success>{title}</Success>
          <SuccessDescription>{description}</SuccessDescription>
        </SuccessView>
        <BtnArea>
          {hasCancelBtn && (
            <CancelBtn onClick={() => modalContext?.setShowModal(false)}>
              Cancel
            </CancelBtn>
          )}
          <SuccessButton onClick={onClick}>{btnLabel}</SuccessButton>
        </BtnArea>
      </SuccessViewWrapper>
    </Container>
  );
};

export default SuccessModal;

const SuccessViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  /* align-items: center; */
`;

const SuccessView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 400px;
  height: 289px;
  padding: 40px 18px;
  background-color: ${({ theme }) => theme.palette.pageBgColor};
`;

const Success = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const SuccessButton = styled.button`
  border: none;
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
  background: linear-gradient(
    262.94deg,
    #436db8 9.61%,
    #5b91f5 49.28%,
    #3c80ff 85.91%
  );
`;

const CancelBtn = styled.button`
  border: none;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
`;

const IconArea = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 16px;
  background: rgba(91, 145, 245, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor};
  }

  &.pink {
    background-color: ${({ theme }) => theme.palette.logiratePrimaryLight};
  }

  &.pink > svg {
    color: ${({ theme }) => theme.palette.logiratePrimary};
  }
`;

const SuccessDescription = styled.div`
  font-size: 14px;
  line-height: 25px;
  font-weight: 400;
  text-align: center;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const BtnArea = styled.div`
  display: flex;
  gap: 16px;
`;

const Container = styled.div<{ width: string }>`
  display: flex;
  flex-direction: column;
  padding: 60px;
  border-radius: 16px;
  background-color: white;
  width: ${({ width }) => width};
  /* width: fit-content; */
  gap: 24px;
  margin-top: 146px;
  margin-bottom: 146px;

  /* background-color: red; */

  @media (max-width: 884px) {
    padding: 32px;
    margin-right: 25px;
    margin-left: 25px;
    width: 500px;
  }

  @media (max-width: 480px) {
    width: 90%;
    padding: 24px;
  }
`;
